namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import models = Portico.Models;

    export interface ISessionDetailService {
        getSessionDetail(jwt: string): angular.IPromise<models.SessionDetailResponse>;
    }

    @Service('app', 'sessionDetailService')
    @Inject('$http', '$q', 'storageService', 'dataService', 'serverConstants', 'modalService')
    export class SessionDetailService implements ISessionDetailService {
        private endPoint = '/api/Session';
        private jwtTokenName;

        constructor(protected $http: ng.IHttpService,
            protected $q: ng.IQService,
            protected storageService: Portico.Services.IStorageService,
            protected dataService: Portico.Services.IDataService,
            protected serverConstants: Portico.Models.Interfaces.IServerConstants,
            protected modalService: Portico.Services.IModalService,
        ) {
            this.$http.defaults.headers.common['accept'] = 'application/json';
            this.$http.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
        }

        public getSessionDetail(jwt: string): angular.IPromise<models.SessionDetailResponse> {
            // this.modalService.show('spinner');
            document.getElementById('global-spinner-overlay').style.display = 'flex';

            const promise = jwt ?
                this.$http.post<models.SessionDetailResponse>(this.endPoint, `"${jwt}"` ) :
                this.$q.when(null);

            return promise.then((response: angular.IHttpPromiseCallbackArg<models.SessionDetailResponse>) => {
                return response.data || null;

            }).finally(() => {
                // this.modalService.hide('spinner');
                document.getElementById('global-spinner-overlay').style.display = 'none';
            });

        }
    }
}